import React from 'react';
import {
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
  Button,
} from '@chakra-ui/react';

interface DeleteProjectDialogProps {
  isOpen: boolean;
  leastDestructiveRef: React.RefObject<HTMLButtonElement>;
  onClose: () => void;
  onDelete: () => void;
  isLoading: boolean;
  projectName?: string;
}

const DeleteProjectDialog: React.FC<DeleteProjectDialogProps> = ({
  isOpen,
  leastDestructiveRef,
  onClose,
  onDelete,
  isLoading,
  projectName,
}) => (
  <AlertDialog isOpen={isOpen} leastDestructiveRef={leastDestructiveRef} onClose={onClose}>
    <AlertDialogOverlay>
      <AlertDialogContent>
        <AlertDialogHeader fontSize="lg" fontWeight="bold">
          Delete Project
        </AlertDialogHeader>
        <AlertDialogBody>
          Are you sure you want to delete "{projectName}"? This action cannot be undone.
        </AlertDialogBody>
        <AlertDialogFooter>
          <Button ref={leastDestructiveRef} onClick={onClose}>
            Cancel
          </Button>
          <Button colorScheme="red" onClick={onDelete} ml={3} isLoading={isLoading}>
            Delete
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialogOverlay>
  </AlertDialog>
);

export default DeleteProjectDialog;
